import * as utils from "../../redux/reducers/utils";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import { const_var, params } from "../../redux/reducers/reducer";
import { getDefaultMetalSiding, getSidingOrientationOptions } from "../building/building_material/buildingMaterial.helper";
import { getUpdatedPriceDataFlags } from "../building_pricing/buildingPricing.helper";
import { resetFees } from "../building_pricing/tax_discount_calculation/taxCalculation.helper";
const initFlagsAndData = (state, action) => {
	const { const_var } = state;
	if (state.const_var.crmSetting.is_Edit !== true || state.const_var.isFromCompare) {
		const_var.manufacturer_discount_label = "";
		const_var.manufacturer_discount_changed = false;
		const_var.edited_manufacturer_discount_label = "";
	}
	if (action.value.is_custom_building === true) {
		const_var.is_custom_building = true;
	}
	if (localStorage.getItem("userData") != undefined && const_var.isPublicEdit !== true) {
		const_var.loginSession = true;
		document.querySelector("body").classList.remove("extraoptionnonlogin");
	}
	state.const_var.showProcessLoaderchkEdit = false;
	const_var.bjDData = action.value.data;
	const_var.stateData = action.value;
};
const setupStateData = (state, action) => {
	const { const_var } = state;
	if (state.const_var.crmSetting.is_Edit == true && const_var.loginSession !== true && const_var.crmSetting?.is_zipcode_screen && const_var.editAPIDataByResponse) {
		const stateId = const_var.editAPIDataByResponse.data?.request_data?.building.state;
		const selectedState = const_var.bjDData != undefined && const_var.bjDData.find((state) => state.id == stateId);
		if (selectedState && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
			const key = `selectedState_${stateId}`;
			state.nonLoggedInpriceCompareData = {
				...state.nonLoggedInpriceCompareData,
				[key]: [selectedState?.manufacturer_list, ...selectedState?.manufacturer_list?.price_comparision]
			};
		}
	}
	if (const_var?.crmSetting?.pre_quote_form || const_var?.crmSetting?.is_zipcode_screen) {
		const isAlreadySelect = state.const_var.bjD != undefined && state.const_var.bjD.length > 0 ? state.const_var.bjD.filter((obj) => obj.name === "Select").length > 0 : false;
		if (!isAlreadySelect) const_var.bjD.push({ name: "Select", id: "Select" });
	} else {
		const_var.bjD.push({ name: "Select", id: "Select" });
	}
	const_var.showStateBoxInZipDefault = action.value.data != undefined && action.value.data.length === 1;
	const_var.zipErrDefaultMessage = action.value.message;
	if (const_var.isCompanyIdChanged == true) {
		const_var.bjD = [];
		const_var.stateManufacturerAcordingAPI = {};
	}
	for (let i = 0; i < action.value.data.length; i++) {
		const item = action.value.data[i];
		const_var.bjD[item.id] = { id: item.id, name: item.state_name };
		const_var.stateNameAcordingAPI[item.id] = item.state_name;
		if (item.manufacturer_list) {
			const_var.stateColorAcordingAPI[item.id] = {
				wall_color: item.manufacturer_list.wall_color,
				roof_color: item.manufacturer_list.roof_color,
				trim_color: item.manufacturer_list.trim_color,
				garageDoorColor: item.manufacturer_list.garageDoorColor
			};
			const_var.stateManufacturerAcordingAPI[item.id] = item.manufacturer_list;
			const_var.stateDataForCompare[item.id] = structuredClone(item.manufacturer_list);
		}
	}
	const_var.estimator_disclaimer = action.value.estimator_disclaimer;
	const_var.hide_price_calculation = action.value.hide_price_calculation;
	const_var.crmSetting.order_now = action.value.is_online_checkout === 1;
	if (action.value.hide_price_calculation === 1) {
		document.querySelector("body").classList.add("active-hidden-price");
	} else {
		document.querySelector("body").classList.remove("active-hidden-price");
	}
};
const initNonEditMode = (state, action) => {
	const { const_var } = state;
	const_var.UpdatedPriceData = {
		roof_style_price_changed: true,
		lifttype_price_changed: true,
		cupola_price_changed: true,
		width_price_changed: true,
		length_price_changed: true,
		height_price_changed: true,
		left_wall_price_changed: true,
		right_wall_price_changed: true,
		right_wall_cut_panel_price_changed: true,
		left_wall_cut_panel_price_changed: true,
		front_wall_price_changed: true,
		back_wall_price_changed: true,
		certificate_price_changed: true,
		common_width_changed: true,
		common_length_changed: true,
		common_height_changed: true,
		utility_price_changed: true,
		front_utility_price_changed: true,
		wainscot_price_changed: true,
		connection_fee_end_changed: true,
		connection_fee_side_changed: true,
		roof_pitch_price_changed: true,
		left_lean_roof_style_price_changed: true,
		left_lean_width_price_changed: true,
		left_lean_length_price_changed: true,
		left_lean_height_price_changed: true,
		left_lean_left_wall_price_changed: true,
		left_lean_front_wall_price_changed: true,
		left_lean_back_wall_price_changed: true,
		left_lean_certificate_price_changed: true,
		left_lean_utility_price_changed: true,
		left_lean_roof_pitch_price_changed: true,
		right_lean_roof_style_price_changed: true,
		right_lean_width_price_changed: true,
		right_lean_length_price_changed: true,
		right_lean_height_price_changed: true,
		right_lean_right_wall_price_changed: true,
		right_lean_front_wall_price_changed: true,
		right_lean_back_wall_price_changed: true,
		right_lean_certificate_price_changed: true,
		right_lean_utility_price_changed: true,
		right_lean_roof_pitch_price_changed: true,
		front_lean_roof_style_price_changed: true,
		front_lean_width_price_changed: true,
		front_lean_length_price_changed: true,
		front_lean_height_price_changed: true,
		front_lean_left_wall_price_changed: true,
		front_lean_front_wall_price_changed: true,
		front_lean_back_wall_price_changed: true,
		front_lean_certificate_price_changed: true,
		front_lean_utility_price_changed: true,
		front_lean_roof_pitch_price_changed: true,
		back_lean_roof_style_price_changed: true,
		back_lean_width_price_changed: true,
		back_lean_length_price_changed: true,
		back_lean_height_price_changed: true,
		back_lean_left_wall_price_changed: true,
		back_lean_front_wall_price_changed: true,
		back_lean_back_wall_price_changed: true,
		back_lean_certificate_price_changed: true,
		back_lean_utility_price_changed: true,
		back_lean_roof_pitch_price_changed: true,
		color_price_changed: true,
		left_front_wrap_connection_fee_changed: true,
		right_front_wrap_connection_fee_changed: true,
		right_back_wrap_connection_fee_changed: true,
		left_back_wrap_connection_fee_changed: true,
		front_lean_insulation_price_changed: true,
		left_lean_insulation_price_changed: true,
		right_lean_insulation_price_changed: true,
		back_lean_insulation_price_changed: true,
		truss_price_changed: true,
		left_lean_right_wall_price_changed: true,
		right_lean_left_wall_price_changed: true,
		front_lean_right_wall_price_changed: true,
		back_lean_right_wall_price_changed: true,
		siding_material_price_changed: true,
		frontLean_truss_price_changed: true,
		backLean_truss_price_changed: true,
		rightLean_truss_price_changed: true,
		leftLean_truss_price_changed: true,
		common_left_lean_length_changed: true,
		common_right_lean_length_changed: true,
		common_front_lean_length_changed: true,
		common_back_lean_length_changed: true,
		common_left_lean_width_changed: true,
		common_right_lean_width_changed: true,
		common_front_lean_width_changed: true,
		common_back_lean_width_changed: true
	};

	const_var.estimator_QuestionAnswer = action.value.questions;
	const_var.estimator_DefaultQuestionAnswer = structuredClone(action.value.questions);
	const_var.user_type_for_comparision = action.value.user_type != undefined ? action.value.user_type : "standard";
	const_var.checkUserRole = action.value.compare != undefined ? action.value.compare : "";
	const_var.two_d_layuot = action.value.two_d_layuot;
	const_var.feedback_object = action.value["3d_feedback"];
	const_var.price_breakdown_key = action.value.price_breakdown;
	const_var.card_processing_fee = action.value.card_processing_fee;

	if (const_var.card_processing_fee != undefined && Object.keys(const_var.card_processing_fee).length > 0) {
		const_var.order_extra_items.dont_show_processing_fee_pdf = const_var.card_processing_fee.add_in === "invoice" ? 2 : 1;
	}
	const_var.order_extra_items.pdf_price_breakdown = const_var.price_breakdown_key[const_var.crmSetting.is_module_name];
};

function initEditMode(state, action) {
	const { const_var } = state;
	const_var.estimator_QuestionAnswer = const_var.estimator_QuestionAnswer.length > 0 ? const_var.estimator_QuestionAnswer : action.value.questions;
	const_var.estimator_DefaultQuestionAnswer = structuredClone(action.value.questions);
	const_var.two_d_layuot = const_var.two_d_layuot && Object.keys(const_var.two_d_layuot).length > 0 ? const_var.two_d_layuot : action.value.two_d_layuot;
	const_var.feedback_object = action.value["3d_feedback"];
	const_var.price_breakdown_key = const_var.price_breakdown_key && Object.keys(const_var.price_breakdown_key).length > 0 ? const_var.price_breakdown_key : action.value.price_breakdown;
	const_var.card_processing_fee = const_var.card_processing_fee && Object.keys(const_var.card_processing_fee).length > 0 ? const_var.card_processing_fee : action.value.card_processing_fee;
	if (const_var.card_processing_fee != undefined && Object.keys(const_var.card_processing_fee).length > 0) {
		if (const_var.editAPIDataByResponse?.data?.request_data && Object.keys(const_var.editAPIDataByResponse).length) {
			const orderExtra = const_var.editAPIDataByResponse?.data?.request_data?.building?.order_extra_items;
			const_var.order_extra_items.dont_show_processing_fee_pdf = orderExtra?.dont_show_processing_fee_pdf ?? (const_var.card_processing_fee.add_in === "invoice" ? 2 : 1);
		} else {
			const_var.order_extra_items.dont_show_processing_fee_pdf = const_var.card_processing_fee.add_in === "invoice" ? 2 : 1;
		}
	}

	const_var.user_type_for_comparision = action?.value?.user_type ?? "standard";
	const_var.checkUserRole = action?.value?.compare ?? "";
	const_var.order_extra_items.pdf_price_breakdown = const_var?.order_extra_items?.pdf_price_breakdown ?? const_var.price_breakdown_key[const_var.crmSetting.is_module_name];

	const_var.stateManufacturerAcordingAPIDiscount["commissions"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["surcharge"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["discount"] = [];
	if (!const_var.isFromCompare) {
		const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"] = [];
	}
	const_var.stateManufacturerAcordingAPIDiscount["manuName"] = [];
}

const initMfgDiscountEntry = (state, mfg) => {
	const { const_var } = state;
	const stateManuFacture = const_var.stateManufacturerAcordingAPIDiscount;
	stateManuFacture["manuName"][mfg.id] = mfg.name;
	if (mfg.commissions?.length > 0) stateManuFacture["commissions"][mfg.id] = mfg.commissions;
	if (mfg.discounts?.length > 0) stateManuFacture["discount"][mfg.id] = mfg.discounts;
	if (mfg.surcharge && Object.keys(mfg.surcharge).length > 0) {
		if (mfg.surcharge.taxable == undefined) {
			mfg.surcharge.taxable = 0;
		}
		stateManuFacture["surcharge"][mfg.id] = mfg.surcharge;
		stateManuFacture["surchargeArray"][mfg.id] = mfg.surcharge;
	}
	if (mfg?.manufacture_discount?.length > 0) {
		stateManuFacture["mfg_discount"][mfg.id] = [];
	} else if (mfg?.discounts?.length > 0) {
		stateManuFacture["mfg_discount"][mfg.id] = [];
		stateManuFacture["discount"][mfg.id].forEach((val1) => {
			if (val1.manufacturer_discount != undefined) {
				stateManuFacture["mfg_discount"][mfg.id].push({
					amount: val1.manufacturer_discount,
					amount_type: val1.manufacturer_discount_in,
					price_from: val1.from,
					price_to: val1.to
				});
			}
		});
	}
};
const applyOrderFees = (state, mfg) => {
	const { const_var, params } = state;
	const isNotEdit = const_var.crmSetting.is_Edit != true;
	const mod = const_var.crmSetting.is_module_name;
	const dup = const_var.crmSetting.duplicate_module;
	const sub = const_var.crmSetting.sub_module;

	const_var.order_extra_items["document_fee"] = mfg.document_fee != null && const_var.order_extra_items["document_fee"] == 0 && isNotEdit ? mfg.document_fee : const_var.order_extra_items["document_fee"];
	const_var.order_extra_items["order_processing_fee"] = mfg.order_processing_fee != null && mfg.order_processing_fee == 0 && isNotEdit ? mfg.order_processing_fee : const_var.order_extra_items["order_processing_fee"];
	if (const_var.order_extra_items["permit"] == "yes") {
		const_var.order_extra_items["order_permit_fee"] =
			mfg.order_permit_fee != null && isNotEdit ? mfg.order_permit_fee : const_var.order_extra_items["order_permit_fee"] != undefined ? const_var.order_extra_items["order_permit_fee"] : 0;
		const_var.exact_order_permit_fee = mfg.order_permit_fee != null && isNotEdit ? mfg.order_permit_fee : const_var.exact_order_permit_fee;
	}
	if (const_var.order_extra_items["order_permit_fee"] !== "" && const_var.order_extra_items["order_permit_fee"] !== 0 && isNotEdit) {
		const_var.order_extra_items["permit"] = "yes";
	}
	const_var.order_extra_items["permit"] = params.m_s_n == 67 ? "cust_verify" : const_var.order_extra_items["permit"];
	const isQuoteDup = mod === "quote" && dup === "quote" && (sub === "" || sub === "lead");
	const isOrderDup = mod === "order" && dup === "order";
	if (isQuoteDup || isOrderDup) {
		const_var.order_extra_items["order_permit_fee"] = mfg.order_permit_fee != null ? mfg.order_permit_fee : 0;
		const_var.exact_order_permit_fee = const_var.order_extra_items["order_permit_fee"];
		const_var.is_edit_labour = undefined;
		const_var.order_extra_items["labor_fee_on"] = mfg.labor_fee_on != undefined ? mfg.labor_fee_on : null;
		const_var.order_extra_items["labor_per_type"] = mfg.labor_fee != undefined ? mfg.labor_fee : 0;
		const_var.order_extra_items["extra_labour"] = mfg.labor_fee != undefined ? mfg.labor_fee : 0;
	}
	if (const_var.order_extra_items["order_permit_fee"] != undefined && const_var.order_extra_items["order_permit_fee"] == 0 && const_var.crmSetting.is_Edit === true && const_var.order_extra_items["permit"] == null) {
		const_var.order_extra_items["permit"] = "no";
	}
	const_var.order_extra_items["labor_fee_on"] = (isNotEdit && mfg?.labor_fee_on) ?? const_var?.order_extra_items["labor_fee_on"] ?? null;
	const_var.order_extra_items["labor_per_type"] = (isNotEdit && mfg?.labor_fee) ?? const_var?.order_extra_items["labor_per_type"] ?? 0;
	if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.order_extra_items["permit"] == "yes" && const_var.order_extra_items["extra_labour"] != null) {
		if (mod === "inventory" && sub === "") {
			const createdAt = const_var.editAPIDataByResponse?.data?.main_created_at;
			if (createdAt != undefined && createdAt <= "2024-03-18") {
				const_var.order_extra_items["extra_labour"] = isNotEdit ? parseFloat(mfg.labor_fee) : parseFloat(const_var.order_extra_items["extra_labour"]) - parseFloat(const_var.exact_order_permit_fee);
			} else {
				const_var.order_extra_items["extra_labour"] = isNotEdit ? parseFloat(mfg.labor_fee) : parseFloat(const_var.order_extra_items["extra_labour"]);
			}
		} else if (mod === "inventory" && dup === "inventory" && sub === "customer") {
			const_var.order_extra_items["extra_labour"] =
				mfg.labor_fee != null && isNotEdit
					? parseFloat(const_var.order_extra_items["order_permit_fee"]) + parseFloat(mfg.labor_fee)
					: parseFloat(const_var.order_extra_items["extra_labour"]) - parseFloat(const_var.exact_order_permit_fee);
		} else {
			const_var.order_extra_items["extra_labour"] =
				mfg.labor_fee != null && isNotEdit
					? parseFloat(const_var.order_extra_items["order_permit_fee"]) + parseFloat(mfg.labor_fee)
					: const_var.is_edit_extra_labour
						? parseFloat(const_var.order_extra_items["extra_labour"])
						: parseFloat(const_var.order_extra_items["order_permit_fee"]) + parseFloat(mfg.labor_fee);
		}
		const_var.order_extra_items["order_permit_fee"] = 0;
	} else {
		const_var.order_extra_items["extra_labour"] = mfg.labor_fee != null && isNotEdit ? mfg.labor_fee : const_var.order_extra_items["extra_labour"];
	}

	if (const_var.isFromPickThis && const_var.order_extra_items["permit"] === "yes") {
		const_var.order_extra_items["order_permit_fee"] = mfg.order_permit_fee != undefined && mfg.order_permit_fee != null ? mfg.order_permit_fee : 0;
	}
	if (const_var.crmSetting.is_Edit === true && const_var.isKLinkEnable !== false) {
		const sm = const_var.stateManufacturerAcordingAPI[params.p_s_n];
		sm.is_permit_show_in_3d = mfg.is_permit_show_in_3d;
		sm.is_labor_show_in_3d = mfg.is_labor_show_in_3d;
		sm.is_document_show_in_3d = mfg.is_document_show_in_3d;
		sm.is_processing_show_in_3d = mfg.is_processing_show_in_3d;

		const_var.order_extra_items["document_fee"] = mfg?.document_fee != null && mfg?.is_document_show_in_3d ? mfg.document_fee : 0;
		const_var.order_extra_items["order_processing_fee"] = mfg?.order_processing_fee != null && mfg.is_processing_show_in_3d ? mfg.order_processing_fee : 0;
		const_var.order_extra_items["labor_fee_on"] = mfg?.labor_fee_on != undefined && mfg.is_labor_show_in_3d ? mfg.labor_fee_on : null;
		const_var.order_extra_items["labor_per_type"] = mfg?.labor_fee != null && mfg.is_labor_show_in_3d ? mfg.labor_fee : 0;
		const_var.order_extra_items["extra_labour"] = mfg?.labor_fee != null && mfg.is_labor_show_in_3d ? mfg.labor_fee : 0;
		const_var.order_extra_items["order_permit_fee"] = mfg?.order_permit_fee != null && mfg.is_permit_show_in_3d ? mfg.order_permit_fee : 0;

		if (const_var.order_extra_items["order_permit_fee"] !== 0) {
			const_var.order_extra_items["permit"] = "yes";
		}
		const_var.order_extra_items["permit"] = params.m_s_n == 67 ? "cust_verify" : const_var.order_extra_items["permit"];
		const_var.exact_order_permit_fee = const_var.order_extra_items["order_permit_fee"];
	} else {
		const sm = const_var.stateManufacturerAcordingAPI[params.p_s_n];
		sm.is_permit_show_in_3d = mfg.is_permit_show_in_3d;
		sm.is_labor_show_in_3d = mfg.is_labor_show_in_3d;
		sm.is_document_show_in_3d = mfg.is_document_show_in_3d;
		sm.is_processing_show_in_3d = mfg.is_processing_show_in_3d;
	}
};

const processManufacturerDiscounts = (state, action) => {
	const { const_var, params } = state;
	const isMultiMfg = Array.isArray(const_var.stateManufacturerAcordingAPI[params.p_s_n]);

	if (isMultiMfg) {
		const_var.stateManufacturerAcordingAPI[params.p_s_n].forEach((val) => {
			initMfgDiscountEntry(state, val);
			if (params.m_s_n == val.id) {
				if (const_var.crmSetting.is_Edit || const_var.isKLinkEnable) {
					resetFees(val);
				}
				applyOrderFees(state, val);
			}
		});
	} else {
		let selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n];
		if (const_var.crmSetting.is_Edit || const_var.isKLinkEnable) {
			resetFees(selMfgInfo);
		}
		if (selMfgInfo?.price_comparision?.length && selMfgInfo.id != params.m_s_n) {
			selMfgInfo = selMfgInfo.price_comparision.find((obj) => obj.id == params.m_s_n);
			if (selMfgInfo == undefined && const_var.crmSetting.is_quote_Edit == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "NoMfgExsist";
				selMfgInfo = const_var.stateManufacturerAcordingAPI[params.p_s_n];
			}
		}
		initMfgDiscountEntry(state, selMfgInfo);
		const selectedState = const_var.stateData?.data?.find((d) => d.id == params.p_s_n);
		let mfgList = selectedState?.manufacturer_list;
		if (const_var.isFromCompare && const_var.crmSetting?.is_zipcode_screen == true && const_var.loginSession == false) {
			mfgList = selectedState;
		}
		(mfgList?.price_comparision || []).forEach((objval) => initMfgDiscountEntry(state, objval));

		if (params.m_s_n == selMfgInfo?.id) {
			applyOrderFees(state, selMfgInfo);
		}
	}
	if (const_var.stateManufacturerNewDiscount?.[params.m_s_n] !== undefined) {
		const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n] = const_var.stateManufacturerNewDiscount[params.m_s_n];
	}
	state.isShowDiscountsPanel = const_var.stateManufacturerNewDiscount[params.m_s_n] != undefined;
	const_var.showDiscountBanner = state.isShowDiscountsPanel;
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url === "nationalcarportsonline.com") {
		const_var.order_extra_items["job_site_level"] = "";
		const_var.order_extra_items["electricity"] = "";
	}
};
export const setDealerStateList = (state, action) => {
	initFlagsAndData(state, action);
	setupStateData(state, action);
	if (state.const_var.crmSetting.is_Edit !== true) {
		initNonEditMode(state, action);
	} else {
		initEditMode(state, action);
		processManufacturerDiscounts(state, action);
	}
};

export function setDiscount(state, action) {
	const { const_var, params } = state;
	let selRespFor = action.forAll == "single" || action.value == undefined ? state.discount_Offers_all : action.value.data;
	if (selRespFor?.length > 0) {
		if (action.forAll == "all") {
			state.discount_Offers_all = action.value.data;
			action.value?.data?.forEach((obj) => {
				obj.offers.length > 0 &&
					obj.offers.forEach((ofr, idx) => {
						obj.offers[idx]["discount_name"] = obj.name;
						obj.offers[idx]["offer_name"] = obj.offers.length == 1 ? "Offer " : "Offer " + (idx + 1);
					});
				const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][obj.manufacturer_id] = obj.offers;
				const_var.stateManufacturerNewDiscount[obj.manufacturer_id] = obj.offers;
			});
		}
		let oldDiscount = const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n];
		let isChanged = false;
		let num = 0;
		let selRespFor = action.forAll == "single" || action.value == undefined ? state.discount_Offers_all : action.value.data;
		let mainResp = [];
		let appliedOfferId = "";
		if (action.forAll == "all") {
			mainResp = selRespFor.filter((all, idx) => {
				if (all.manufacturer_id == params.m_s_n) {
					appliedOfferId = idx + 1;
					return all;
				}
			});
		} else {
			mainResp = selRespFor.filter((all) => {
				if (all.manufacturer_id == action.msnID) {
					return all;
				}
			});
		}

		if (mainResp.length > 0) {
			let discount_banner = false;
			let discount_Offers = "";
			let discount_Offers_end_date = "";
			if (mainResp[0].offers.length > 0) {
				discount_banner = true;
				discount_Offers = mainResp;
				discount_Offers_end_date = discount_Offers[0].end_date;
				discount_Offers[0]["discount_name"] = discount_Offers[0].discount_name;
				discount_Offers[0]["offer_name"] = appliedOfferId;
			} else if (mainResp[0].offers == 0) {
				/*Add this condition to manage no offer discount*/
				discount_banner = true;
				discount_Offers = mainResp;
				discount_Offers_end_date = discount_Offers[0].end_date;
				discount_Offers[0]["discount_name"] = discount_Offers[0].discount_name;
			}
			/*Add this condition to manage no offer discount*/
			if (discount_Offers != undefined && discount_Offers.length > 0) {
				discount_Offers.map((item) => {
					if (item?.offers != undefined && item?.offers?.length > 0)
						item.offers.forEach((offer) => {
							if (offer.amount > num) {
								num = parseFloat(offer.amount);
							}
						});
				});
				if (num > 0) {
					state.higherOfferPercentage = num;
				}
			}
			if (selRespFor?.length > 0 && params.m_s_n != undefined && const_var.ComparisionDataArray == undefined) {
				const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n] = discount_Offers[0]?.offers?.length > 0 ? discount_Offers[0]?.offers : [];
				isChanged =
					const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n] &&
					JSON.stringify(oldDiscount) != JSON.stringify(const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n])
						? true
						: false;
			}
			if (const_var.ComparisionDataArray != undefined && action.msnID != undefined) {
				if (selRespFor?.length > 0 && const_var.ComparisionDataArray != undefined) {
					const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][action.msnID] = discount_Offers[0]?.offers?.length > 0 ? discount_Offers[0]?.offers : [];
					isChanged =
						const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][action.msnID] &&
						JSON.stringify(oldDiscount) != JSON.stringify(const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][action.msnID])
							? true
							: false;
				}
			}

			if (action.isComp == true) {
				const_var.discount_Offers_end_date = discount_Offers_end_date;
				const_var.discount_Offers = discount_Offers;
			} else {
				state.discount_banner = discount_banner;
				state.discount_Offers = discount_Offers;
				state.discount_Offers_end_date = discount_Offers_end_date;
			}
		} else {
			if (action.isComp) {
				const_var.discount_Offers_end_date = "";
				const_var.discount_Offers = [];
			} else {
				state.discount_banner = false;
				state.discount_Offers = [];
				state.higherOfferPercentage = 0;
				if (const_var.post_data.building != undefined) {
					const_var.post_data["building"].freebies = [];
				}
			}
		}
		if (state.const_var.crmSetting.is_Edit == true) {
			cuBuilding.cP();
			const_var.check_siding_material_price = false;
		}
	} else {
		if (const_var.ComparisionDataArray != undefined && action.msnID != undefined && selRespFor.length > 0) {
			if (selRespFor?.length > 0 && const_var.ComparisionDataArray != undefined) {
				const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][action.msnID] = state?.discount_Offers[0]?.offers?.length > 0 ? state?.discount_Offers[0]?.offers : [];
			}
		} else {
			state.discount_banner = false;
			state.discount_Offers = [];
			state.higherOfferPercentage = 0;
			if (const_var.post_data.building != undefined) {
				const_var.post_data.building.freebies = [];
			}
		}
	}
	if (const_var.stateManufacturerNewDiscount[params.m_s_n] != undefined) {
		state.isShowDiscountsPanel = true;
		const_var.showDiscountBanner = state.isShowDiscountsPanel;
	}
	state.showDiscountBanners = true;
	const_var.showDiscountBanner = state.isShowDiscountsPanel;
	const_var.card_processing_fee = const_var.stateData.card_processing_fee;
	if (
		const_var.crmSetting.is_Edit == true &&
		const_var.editAPIDataByResponse.data.request_data.building.card_processing_fee != undefined &&
		const_var.editAPIDataByResponse.data.request_data.building.card_processing_fee.is_edit == true
	) {
		const_var.card_processing_fee.is_edit = true;
	} else {
		const_var.card_processing_fee.is_edit = undefined;
	}
}
export const stateManufacturerChange = (state, value, key) => {
	const { params, const_var } = state;

	state.const_var.UpdatedPriceData = getUpdatedPriceDataFlags();
	params.o_v_h_n_g = false;
	params.o_v_h_n_g_e = false;
	const_var.card_processing_fee.is_edit = undefined;
	const_var.is_edit_labour = undefined;
	state.isShowDiscountsPanel = false;
	const_var.showDiscountBanner = state.isShowDiscountsPanel;
	state.const_var.selSidingOption = "metal";
	state.params.wallOrientation = "horizontal";
	state.params.wainscotTexture = "none";
	state.const_var.mainSidingOptions = [];
	state.const_var.selSidingObj = getDefaultMetalSiding();
	state.const_var.sidingOrientationOptions = getSidingOrientationOptions();
	params.p_s_c_b = false;
	params.p_e_c_b = false;
	state.params.added_building_bracing = {
		p_e_c_b_l: false,
		p_s_c_b_l: false,
		p_e_c_b_r: false,
		p_s_c_b_r: false,
		p_e_c_b_f: false,
		p_s_c_b_f: false,
		p_e_c_b_b: false,
		p_s_c_b_b: false
	};
	const_var.selected_scbracing = "";
	const_var.selected_ecbracing = "";
	const_var.selectedBracingForAddedBuilding = {
		left_lean_end: "",
		left_lean_side: "",
		right_lean_end: "",
		right_lean_side: "",
		front_lean_end: "",
		front_lean_side: "",
		back_lean_end: "",
		back_lean_side: ""
	};
	const_var.LNTCrossBracing = { left: [], right: [], front: [], back: [] };

	if (key == "state") {
		if (const_var.isKLinkEnable == true || const_var.crmSetting.is_Edit == true) {
			let isStateExistInStateManuApi = const_var.stateManufactureDataFromApi?.findIndex((item) => item.id == state.params.p_s_n);

			if (isStateExistInStateManuApi == -1) {
				delete state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n];
				delete state.const_var.bjD[state.params.p_s_n];

				let newBjdData = const_var.bjDData.filter((item) => item.id != state.params.p_s_n);
				const_var.bjDData = newBjdData;
			}
		}

		state.params.p_s_n = parseInt(value);
		const defaultManufacture = state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n][0];
		state.params.m_s_n = defaultManufacture.id;
		state.params.manufactureKey = defaultManufacture.u_id;
		state.params.p_r_o = false;
		state.params.p_f_i = false;
		state.params.p_c_i = false;
		const_var.insulationPriceJson = [];
		const_var.insulationJsonLeanTo = [];
		const_var.insulationArrayForLeantoLeft = [];
		const_var.insulationArrayForLeantoFront = [];
		const_var.insulationArrayForLeantoBack = [];
		const_var.insulationArrayForLeantoRight = [];
	} else {
		if (const_var.crmSetting.is_Edit == true) {
			let isStateExistInStateManuApi = const_var.stateManufactureDataFromApi?.findIndex((item) => item.id == state.params.p_s_n);

			if (isStateExistInStateManuApi > 0) {
				if (
					const_var.stateManufactureDataFromApi &&
					const_var.stateManufactureDataFromApi[isStateExistInStateManuApi] &&
					const_var.stateManufactureDataFromApi[isStateExistInStateManuApi]?.manufacturer_list &&
					const_var.stateManufactureDataFromApi[isStateExistInStateManuApi]?.manufacturer_list?.length > 0
				) {
					state.const_var.stateManufacturerAcordingAPI = {};
					for (let i = 0; i < const_var.stateManufactureDataFromApi.length; i++) {
						state.const_var.stateManufacturerAcordingAPI[const_var.stateManufactureDataFromApi[i].id] = const_var.stateManufactureDataFromApi[i].manufacturer_list;
					}

					state.const_var.bjDData = [];
					state.const_var.bjDData = const_var.stateManufactureDataFromApi;
				}
			}
		}
		state.params.m_s_n = isNaN(value) ? value : parseInt(value);
		const selectedState = state.const_var.stateManufactureDataFromApi.find((item) => item.id === state.params.p_s_n);
		state.params.manufactureKey = selectedState.manufacturer_list.find((manufacture) => manufacture.id === state.params.m_s_n).u_id;
		state.params.p_r_o = false;
		state.params.p_f_i = false;
		state.params.p_c_i = false;
		const_var.insulationPriceJson = [];
		const_var.insulationJsonLeanTo = [];
		const_var.insulationArrayForLeantoLeft = [];
		const_var.insulationArrayForLeantoFront = [];
		const_var.insulationArrayForLeantoBack = [];
		const_var.insulationArrayForLeantoRight = [];
	}
};

export const updateManufacture = (state, data) => {
	const { params, const_var } = state;

	if (params.m_s_n == 29 || params.m_s_n == 122) const_var.hightCategory = "leg_height";
	else const_var.hightCategory = "slant_height";
	const_var.isFromPickThis = false;
	const_var.showAppliedButton = false;
	const_var.showActiveButton = false;
	if (state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n] && state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].price_comparision?.length == 0) {
		const_var.hideCompareOption = true;
	} else {
		const_var.hideCompareOption = false;
	}

	if (params.p_s_n != "" && params.m_s_n != "" && const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true) {
		let manuID =
			state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].length > 1
				? state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].filter((obj) => obj.id == state.params.m_s_n)[0]
				: state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n];

		const_var.isZipcodeIncluded = manuID.is_zipcode_included != undefined ? (manuID.is_zipcode_included == 0 ? false : true) : true;
	}
	const_var.stateManufacturerAcordingAPIDiscount["commissions"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["surcharge"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["discount"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"] = [];
	const_var.stateManufacturerAcordingAPIDiscount["manuName"] = [];
	if (const_var.loginSession != false) {
		const id = params.m_s_n;
		const_var.stateManufacturerAcordingAPIDiscount["manuName"][id] = data.name;
		if (data?.commissions?.length > 0) {
			data.commissions = data.commissions.map((ele) => ({
				...ele,
				percentage: 10
			}));
			const_var.stateManufacturerAcordingAPIDiscount["commissions"][id] = data.commissions;
		}
		if (data?.discounts?.length > 0) {
			const_var.stateManufacturerAcordingAPIDiscount["discount"][id] = data.discounts;
		}
		if (data?.surcharge != undefined && Object.keys(data?.surcharge).length > 0) {
			if (data?.surcharge?.taxable == undefined) {
				data.surcharge.taxable = 0;
			}
			const_var.stateManufacturerAcordingAPIDiscount["surcharge"][id] = data.surcharge;
			const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][id] = data.surcharge;
		}
		const_var.order_extra_items["document_fee"] = data.document_fee != null ? data.document_fee : 0;
		const_var.order_extra_items["order_processing_fee"] = data.order_processing_fee != null ? data.order_processing_fee : 0;
		const_var.order_extra_items["order_permit_fee"] = data.order_permit_fee != null ? data.order_permit_fee : 0;
		const_var.exact_order_permit_fee = data.order_permit_fee != null ? data.order_permit_fee : 0;
		if (const_var.order_extra_items["order_permit_fee"] != "" && const_var.order_extra_items["order_permit_fee"] != 0) {
			const_var.order_extra_items["permit"] = "yes";
		}
		const_var.order_extra_items["labor_fee_on"] = data.labor_fee_on != undefined ? data.labor_fee_on : null;
		const_var.order_extra_items["labor_per_type"] = data.labor_fee != undefined ? data.labor_fee : 0;
		if (params.m_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.order_extra_items["permit"] == "yes" && data.labor_fee != null) {
			if (const_var.crmSetting.is_module_name == "inventory" && params.m_s_n == 3) {
				const_var.order_extra_items["extra_labour"] = parseFloat(data.labor_fee);
			} else {
				const_var.order_extra_items["extra_labour"] = parseFloat(const_var.order_extra_items["order_permit_fee"]) + parseFloat(data.labor_fee);
			}
			const_var.order_extra_items["order_permit_fee"] = 0;
		} else {
			const_var.order_extra_items["extra_labour"] = data.labor_fee != null ? data.labor_fee : 0;
		}
		if (data.manufacture_discount != undefined && data.manufacture_discount.length > 0) {
			const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][id] = [];
		} else if (data?.discounts?.length > 0) {
			const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][id] = [];
			const_var.stateManufacturerAcordingAPIDiscount["discount"][id].map((val1) => {
				if (val1.manufacturer_discount != undefined) {
					const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][id].push({
						amount: data.manufacturer_discount,
						amount_type: data.manufacturer_discount_in,
						price_from: data.from,
						price_to: data.to
					});
				}
			});
		}
	} else {
		const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].commissions;
		const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].discounts;
		if (const_var.stateManufacturerAcordingAPI[params.p_s_n].manufacture_discount != undefined) {
			const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n] = [];
		} else if (const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n].length > 0) {
			const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n] = [];
			const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n].map((val1) => {
				if (val1.manufacturer_discount != undefined) {
					const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n].push({
						amount: data.manufacturer_discount,
						amount_type: data.manufacturer_discount_in,
						price_from: data.from,
						price_to: data.to
					});
				}
			});
		}

		const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge;
		const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].surcharge;
		if (
			const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
			const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
			Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
		) {
			if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable == undefined) {
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable = 0;
			}
		}
		const_var.stateManufacturerAcordingAPIDiscount["manuName"][params.m_s_n] = const_var.stateManufacturerAcordingAPI[params.p_s_n].name;
		const_var.order_extra_items["document_fee"] =
			const_var.stateManufacturerAcordingAPI[params.p_s_n].document_fee != null && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_document_show_in_3d == true
				? const_var.stateManufacturerAcordingAPI[params.p_s_n].document_fee
				: 0;
		const_var.order_extra_items["order_processing_fee"] =
			const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee != null && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_processing_show_in_3d == true
				? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_processing_fee
				: 0;
		const_var.order_extra_items["order_permit_fee"] = const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee != null ? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee : 0;
		const_var.exact_order_permit_fee = const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee != null ? const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee : 0;
		if (const_var.order_extra_items["order_permit_fee"] != "" && const_var.order_extra_items["order_permit_fee"] != 0) {
			const_var.order_extra_items["permit"] = "yes";
		}
		if (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d == false) {
			const_var.order_extra_items["order_permit_fee"] = 0;
			const_var.exact_order_permit_fee = 0;
			const_var.order_extra_items["permit"] = "no";
		}
		const_var.order_extra_items["labor_fee_on"] = const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee_on != undefined ? const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee_on : null;
		const_var.order_extra_items["labor_per_type"] = const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee != undefined ? const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee : 0;
		if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.order_extra_items["permit"] == "yes" && const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee != null) {
			if (const_var.crmSetting.is_module_name == "inventory") {
				const_var.order_extra_items["extra_labour"] = parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee);
			} else {
				const_var.order_extra_items["extra_labour"] = parseFloat(const_var.order_extra_items["order_permit_fee"]) + parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee);
			}
		} else {
			const_var.order_extra_items["extra_labour"] = const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee != null ? const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee : 0;
		}
		if (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d == false) {
			const_var.order_extra_items["extra_labour"] = 0;
		}
		if (
			params.p_s_n == 29 &&
			(params.m_s_n == 3 || params.m_s_n == 9) &&
			const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d == false &&
			const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d == true
		) {
			const_var.order_extra_items["extra_labour"] = const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee;
			const_var.exact_order_permit_fee = const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee;
			const_var.order_extra_items["order_permit_fee"] = 0;
		}
	}
};
export const stateManufacturerDataChange = (state, action) => {
	const initValue = 2;
	params.b_l_t_r_pF = initValue;
	params.b_l_t_r_pB = initValue;
	params.b_l_t_r_pR = initValue;
	params.b_l_t_r_p = initValue;
	const_var.checkmoreCustomizeFlag = false;
	const_var.wainscotApiCall = "";
	const_var.dealer_discount_label = "";
	const_var.manufacturer_discount_label = "";
	const_var.manufacturer_discount_changed = false;
	const_var.edited_manufacturer_discount_label = "";
	if (
		state.const_var.crmSetting.is_zipcode_screen != undefined &&
		state.const_var.crmSetting.is_zipcode_screen == true &&
		action.key == "state" &&
		state.const_var.showStateZip != undefined &&
		state.const_var.showStateZip == true
	) {
		state.const_var.state_mfg_zipcode = "";
	}
	const_var.eventKey = "garages";
	if (const_var.i_g_A_y && const_var.i_g_A_y.length > 0 && const_var.crmSetting.form_action !== "edit") {
		const_var.i_g_A_y = [];
		state.isShowPhotoModal = false;
	}
	if (const_var.order_extra_items && const_var.order_extra_items.additional_note !== undefined && const_var.order_extra_items.additional_note.length > 0) {
		const_var.order_extra_items.additional_note = "";
	}
	const_var.navEventKey.leanto = "leftLean";

	state.const_var.crmSetting.is_show_background = false;
	if (state.const_var.crmSetting.api_token == "t1HZNdPUVH6uq1obAdePC8wlNOOE0yzIowZGeryk6cYcvTJ2NxQJ8rACJ4rvWRZV") {
		state.const_var.crmSetting.is_show_background = true;
		document.querySelector("body").classList.add("activebuildingbg");
	}
	const_var.hide_price_calculation = const_var?.stateData?.hide_price_calculation;
	if (const_var.hide_price_calculation == 0 && document.querySelector("body").classList.contains("active-hidden-price")) {
		document.querySelector("body").classList.remove("active-hidden-price");
	}
	if (const_var.loginSession != false) {
		state.priceBookFile = [];
	}

	state.showDiscountBanners = false;

	if (localStorage.getItem("userData") != undefined) {
		let userData = JSON.parse(localStorage.getItem("userData"));
		const_var.userCompanies = userData.user_companies;
	}

	stateManufacturerChange(state, action.value, action.key);
	return {
		...state,
		newColor: action.value + action.key
	};
};

export const handleManufacturerChange = (state, action) => {
	if (action.key == "state") {
		params.p_s_n = action.value;
	}
	if (action.key == "manufacture") {
		params.m_s_n = action.value;
	}

	return {
		...state,
		newColor: params.p_s_n
	};
};
export const handleManufacturerModal = (state, action) => {
	const_var.isShowAlert = true;
	const_var.alertUsedFor = action.value;
	const_var.stateManufactureChangeId = action.id;
	const_var.stateManufactureFlag = action.flag;
	return {
		...state,
		action
	};
};
